import { Delete } from "./Delete";
import { Download } from "./Download";
import { Edit } from "./Edit";
import { Lock } from "./Lock";
import { Timer } from "./Timer";

export var Actions = {
  Download,
  Timer,
  Lock,
  Delete,
  Edit,
};
